// src/components/Resources/Brochures.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Resources.css';

const Brochures = () => {
  // PDF file path
  const pdfUrl = '/brochures/aicis-2026-brochure.pdf';

  useEffect(() => {
    // Open PDF in a new tab
    window.open(pdfUrl, '_blank');
  }, [pdfUrl]);

  return (
    <div className="brochures-page">
      <div className="brochures-container">
        <div className="brochures-redirect">
          <div className="redirect-content">
            <div className="redirect-icon">📄</div>
            <h2>Opening Brochure...</h2>
            <p>If the brochure doesn't open automatically, click the button below.</p>
            <a 
              href={pdfUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="redirect-btn"
            >
              📘 Open Brochure in New Tab
            </a>
            <Link to="/" className="redirect-back">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brochures;